import { StyledCell } from '../../Table.style';
import MultipleAvatars from 'components/MultipleAvatars';
import { ICON_SIZES } from 'common/constants/sizes';

const AuthorsCell = ({ contributors = [] }) => {
  const avatars = contributors
    .map(contributor => {
      const name = contributor?.name;
      const email = contributor?.email;
      if (!name && !email) return false;

      const url = contributor?.extended_data?.avatar_url;
      return {
        name,
        email,
        url
      };
    })
    .filter(Boolean);

  return (
    <StyledCell>
      <MultipleAvatars
        disableTooltipForRest={true}
        avatars={avatars}
        limit={4}
        size={ICON_SIZES['x-medium']}
      />
    </StyledCell>
  );
};

export default AuthorsCell;
